import { useMemo } from 'react'
import { useGuidToElementIncludingRips, usePositionGuidToWallGuid } from '@editorHooks'
import { getElementDirectionForTextDirection } from './utils'

const useElementDirectionForTextDirection = (elementGuid: string) => {
  const guidToElement = useGuidToElementIncludingRips()
  const positionGuidToWallGuid = usePositionGuidToWallGuid()

  return useMemo(
    () => getElementDirectionForTextDirection(elementGuid, guidToElement, positionGuidToWallGuid),
    [elementGuid, guidToElement, positionGuidToWallGuid],
  )
}

export default useElementDirectionForTextDirection
